export default "__VITE_ASSET__e29b015a__"